import React from 'react'

export default function ProgressChartLegendItem(props) {
  const {color, label1, label2} = props;

  return (
    <div className='progressLegendItem'>
      <div className='progressLegendSquare' style={{backgroundColor: color}} />
      <div className='multilineItem legendLabel'>
        <div>{label1}</div>
        <div>{label2}</div>
      </div>
    </div>
  )
}
